import { api } from "@api/api";
import { IntegrationCatalog } from "@modules/erpIntegrations/types";
import { IntegrationFormValues } from "@modules/erpIntegrations/validations";

export async function createIntegrationService(
  data: IntegrationFormValues
): Promise<IntegrationCatalog> {
  const { data: integration } = await api.post<IntegrationCatalog>(
    "/v1/integration_admin/",
    {
      name: data.name,
      description: data.description ?? "",
      documentation_url: data.documentation_url ?? "",
      instructions: data.instructions ?? "",
      features: data.features ?? [],
      active: data.active ?? true,
      credential_schema: data.credential_schema ?? [],
    }
  );

  return integration;
}
